import React, { useState } from "react";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { GetSubscriptionSetData } from "../../../../Api/ServiceDatas";
import { useApi } from "../../../../hooks/useApi";
import {
  IPartyMatching,
  matchingFilterState,
} from "../../../../pages/Party/MatchingInfo";
import LineBtn from "../../../Button/LineBtn";
import Blank from "../../../DefaultStyles/Blank";
import DotStatus from "../../../DefaultStyles/DotStatus";
import LineBox from "../../../DefaultStyles/LineBox";
import TitleWithLine from "../../../DefaultStyles/TitleWithLine";
import Pagination from "../../../Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { getSubsNameBySubsId3 } from "../../../../AdminApi/3.0_utils";

interface UserDetailMatchingInfoProps {
  userId?: string;
}

dayjs.extend(isBetween); // 플러그인 등록
dayjs.extend(isSameOrBefore); // 플러그인 등록

dayjs.locale("ko"); // 언어 등록

export default function UserDetailMatchingInfo({
  userId,
}: UserDetailMatchingInfoProps) {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const setMatchingInfoFilter = useSetRecoilState(matchingFilterState);

  const { response: matchingResponse } = useApi({
    method: "get",
    url: `party/request?page=${page}&size=5&uid=${userId}`,
  });

  const matchingInfoHeader = [
    "Subscription",
    "상태",
    "매칭 시작일",
    "매칭 종료일",
    "파티 기간",
    "조회",
  ];

  return (
    <>
      {matchingResponse?.data?.items?.length > 0 && (
        <>
          <LineBox>
            <>
              <TitleWithLine title="매칭 정보" />

              <Blank blankHeight={24} />

              <Table tableHeadData={matchingInfoHeader} tableMinWidth={965}>
                <>
                  {matchingResponse?.data?.items?.map(
                    (d: IPartyMatching, index: number) => {
                      const today = dayjs().format("YYYY-MM-DD");

                      return (
                        <TableBody key={index}>
                          <TableBodyItem>
                            {d?.servsubsid}_
                            {getSubsNameBySubsId3(d?.servsubsid)}
                          </TableBodyItem>
                          <TableBodyItem>
                            <DotStatus
                              text={
                                dayjs(today).isSameOrAfter(
                                  dayjs(d?.sdate).format("YYYY-MM-DD")
                                ) &&
                                dayjs(today).isSameOrBefore(
                                  dayjs(d?.edate).format("YYYY-MM-DD")
                                )
                                  ? "매칭중"
                                  : dayjs(d?.sdate).isAfter(
                                      dayjs(dayjs().format("YYYY-MM-DD"))
                                    )
                                  ? "매칭 예정"
                                  : "매칭 만료"
                              }
                              color={
                                dayjs(today).isSameOrAfter(
                                  dayjs(d?.sdate).format("YYYY-MM-DD")
                                ) &&
                                dayjs(today).isSameOrBefore(
                                  dayjs(d?.edate).format("YYYY-MM-DD")
                                )
                                  ? "#00c7c7"
                                  : dayjs(d?.sdate).isAfter(
                                      dayjs(dayjs().format("YYYY-MM-DD"))
                                    )
                                  ? "#ffb100"
                                  : "#f42d16"
                              }
                              size="sm"
                            />
                          </TableBodyItem>

                          <TableBodyItem>
                            {dayjs(d?.sdate)?.format("YYYY-MM-DD")}
                          </TableBodyItem>
                          <TableBodyItem>
                            {dayjs(d?.edate)?.format("YYYY-MM-DD")}
                          </TableBodyItem>
                          <TableBodyItem>
                            {d?.pmin === d?.pmax
                              ? `${d?.pmin}개월`
                              : `${d?.pmin}~${d?.pmax}개월`}
                          </TableBodyItem>

                          <TableBodyItem>
                            <LineBtn
                              btnText="조회"
                              btnClickEvent={() => {
                                setMatchingInfoFilter({
                                  filterType: {
                                    label: "UID",
                                    value: "uid",
                                  },
                                  searchValue: userId ?? "",
                                  page: 0,
                                });

                                navigate(`/party/matching`);
                              }}
                            />
                          </TableBodyItem>
                        </TableBody>
                      );
                    }
                  )}
                </>
              </Table>

              <Pagination
                totalPage={
                  matchingResponse?.status === 200
                    ? matchingResponse?.data?.totalPage
                    : 3
                }
                currentPage={page}
                pageClickEvent={(index) => setPage(index)}
              />
            </>
          </LineBox>

          <Blank blankHeight={20} />
        </>
      )}
    </>
  );
}
